// context/ProductContext.js

import React, { createContext, useState } from "react";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [evento, setEvento] = useState(null); // o el objeto que usás por defecto
  const [reserva, setReserva] = useState({
    idEntidad: 0,
    totalReserva: 0,
    tarifaBaseAdulto: 0,
    tarifaBaseMenor: 0,
    paxTotales: 0,
    observacion: "",
    direccion: "",
    idTipoDocumento: 1,
    numeroDocumento: "",
    idEvento: 0,
    titular: "",
    email: "",
    telefono: "",
    evento: { 
            fecha: "" 
            },
    mesas: [],
    sillas: [],
  });

  const handleInputChange = (name, value) => {
    setReserva(prev => ({ ...prev, [name]: value }));
  };

  const handleEvento = (eventoSeleccionado) => {
    setEvento(eventoSeleccionado);
  };

  const calcularTotal = () => {
    if (!reserva) return 0;

    
    return (
      Number(parseFloat(reserva?.tarifaBaseAdulto) || 0) * reserva?.pasajeros.paxAdultos.length +
      Number(parseFloat(reserva?.tarifaBaseMenor )|| 0) * reserva?.pasajeros.paxMenores.length
    ).toFixed(2);
  };

  const calcularTotalPax = () => {
    return Number(reserva.pasajeros.paxAdultos.length) + Number(reserva.pasajeros.paxMenores.length);
  };

  return (
    <ProductContext.Provider
      value={{
        evento,
        reserva,
        setEvento: handleEvento,
        setReserva,
        handleInputChange,
        calcularTotal,
        calcularTotalPax,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};